import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import type { OrganizationMember } from 'services/api';
import { formatPeopleDate } from '../formatPeopleDate';

const TEXT_COLOR = '#383838';
const ROW_BORDER = '#DEDEDE';

export function MemberRosterMobileCards ({
  members,
  onRowPress,
}: {
  members: OrganizationMember[];
  onRowPress: (member: OrganizationMember) => void;
}): ReactElement {
  return (
    <Box sx={{ width: '100%', pb: '24px' }}>
      {members.map((m, idx) => {
        const isLast = idx === members.length - 1;
        return (
          <Box
            key={m.id}
            component="button"
            type="button"
            onClick={() => onRowPress(m)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: '100%',
              padding: '16px 0',
              cursor: 'pointer',
              backgroundColor: 'transparent',
              textAlign: 'left',
              borderWidth: 0,
              borderTopWidth: 1,
              borderBottomWidth: isLast ? 1 : 0,
              borderStyle: 'solid',
              borderColor: ROW_BORDER,
            }}
          >
            <Box display="flex" flexDirection="column" gap="8px" width="100%">
              <Box display="flex" gap="16px" alignItems="center" width="100%">
                <Box flex={1} minWidth={0}>
                  <Typography
                    sx={{
                      fontFamily: '\'Poppins\', sans-serif',
                      fontSize: '14px',
                      fontWeight: 500,
                      lineHeight: '24px',
                      color: TEXT_COLOR,
                    }}
                  >
                    {m.firstName} {m.lastName}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: '\'Poppins\', sans-serif',
                      fontSize: '11px',
                      fontWeight: 400,
                      lineHeight: '18px',
                      color: TEXT_COLOR,
                    }}
                  >
                    {m.schoolEmail}
                  </Typography>
                </Box>
                <ChevronRightIcon sx={{ fontSize: 24, color: TEXT_COLOR, flexShrink: 0 }} />
              </Box>

              <Typography
                sx={{
                  fontFamily: '\'Poppins\', sans-serif',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '18px',
                  color: TEXT_COLOR,
                }}
              >
                {(m.classification || '—')} · {(m.major || '—')}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '\'Poppins\', sans-serif',
                  fontSize: '11px',
                  fontWeight: 400,
                  lineHeight: '18px',
                  color: TEXT_COLOR,
                }}
              >
                Joined {formatPeopleDate(m.dateJoined)} · Last attended {formatPeopleDate(m.lastAttended)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
